const stats = [
  { value: '500+', label: '服务品牌客户', icon: 'ri-building-line' },
  { value: '10,000+', label: '原创内容产出', icon: 'ri-file-text-line' },
  { value: '50亿+', label: '累计内容曝光', icon: 'ri-eye-line' },
  { value: '98%', label: '客户满意度', icon: 'ri-heart-line' },
];

export default function Stats() {
  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-background-50/20 flex items-center justify-center">
                <i className={`${stat.icon} text-xl text-background-50`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-background-200 text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}